import React from 'react';
import { Helmet } from 'react-helmet-async';
import PublicHeader from '../../components/ui/PublicHeader';
import HowItWorksSection from '../home-landing/components/HowItWorksSection';
import Footer from '../home-landing/components/Footer';

const HowItWorksPage = () => {
  return (
    <>
      <Helmet>
        <title>How It Works - Bamchik</title>
        <meta
          name="description"
          content="Learn how Bamchik works: create an anonymous profile, control your privacy, and connect safely."
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <PublicHeader />
        <main className="pt-4">
          <HowItWorksSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HowItWorksPage;
